import React, { useMemo } from 'react'
import InclusionItem from 'components/Common/InclusionItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import AccommodationPackageInclusionsList from '../Accommodation/AccommodationPackageInclusionsList'

interface Props {
  inclusions: Array<App.PackageInclusionV2>;
  size?: 'small' | 'medium' | 'large';
}

function InclusionsV2Section(props: Props) {
  const { inclusions, size = 'medium' } = props

  const { bonusInclusions, regularInclusions } = useMemo(() => {
    const bonusInclusions: Array<App.PackageInclusionV2> = []
    const regularInclusions: Array<App.PackageInclusionV2> = []

    for (const inclusion of inclusions) {
      if (inclusion.style === 'bonus') {
        bonusInclusions.push(inclusion)
      } else {
        regularInclusions.push(inclusion)
      }
    }

    return { bonusInclusions, regularInclusions }
  }, [inclusions])

  return <VerticalSpacer gap={12}>
    {!!bonusInclusions.length && <AccommodationPackageInclusionsList title="bonus">
      {bonusInclusions.map(({ inclusion }) => <InclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
    </AccommodationPackageInclusionsList>}
    <AccommodationPackageInclusionsList title={bonusInclusions.length ? 'additional' : undefined}>
      {regularInclusions.map(({ inclusion, style }) => <InclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted={style === 'highlighted'} size={size} />)}
    </AccommodationPackageInclusionsList>
  </VerticalSpacer>
}

export default InclusionsV2Section
